export const CreateNewAccountMailAPI = async (email, name) => {
    try {

        const response = await fetch(`${process.env.REACT_APP_BASE_URL}send-welcome-mail`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                email: email,
                name: name
            })
        });

        if (!response.ok) {
            console.error(`Failed to send mail, status: ${response.status}`);
            return null;
        }

        // Attempt to parse JSON response
        const data = await response.json();


    } catch (error) {
        console.error("Error sending mail:", error);
        return null;
    }
};
